module.exports = __webpack_public_path__ + "img/Air-Conditioner.a853afc5.svg";